import { render } from "./CreateConsentPage.vue?vue&type=template&id=2c6e51ee&ts=true"
import script from "./CreateConsentPage.vue?vue&type=script&lang=ts"
export * from "./CreateConsentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Consent/CreateConsentPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c6e51ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c6e51ee', __exports__)) {
    api.reload('2c6e51ee', __exports__)
  }
  
  module.hot.accept("./CreateConsentPage.vue?vue&type=template&id=2c6e51ee&ts=true", () => {
    api.rerender('2c6e51ee', render)
  })

}


export default __exports__